export default __webpack_public_path__ + "static/media/information.af0aab68.svg";